module.exports = __webpack_public_path__ + "static/media/winter-che-big-mobile.c7cb3e23.png";